import { all, call, put, fork, takeEvery, select } from 'redux-saga/effects';
import { fetchOrgSurveyAnswersSuccess, onSaveOrgSurveyAnswersSuccess, showOrgSurveyAnswersMessage } from 'actions/OrgSurveyAnswers';
import { FETCH_ORG_SURVEY_ANSWERS, ON_SAVE_ORG_SURVEY_ANSWERS} from 'constants/ActionTypes';
import { fetchDataRequest, addOrUpdateDataRequest } from 'services/ApiService';
import { ORGID_PATH_PARAM, ORG_SURVEY_ANSWERS_ENDPOINT } from 'constants/api';

const currentOrg = (state) => state.orgs.selectedOrg;

function* fetchOrgSurveyAnswers({ payload }) {
    try {
        // payload will be the orgSurveyId to fetch
        const selectedOrg = yield select(currentOrg);
        if (payload ?.orgSurveyId) {
            const answers = yield call(
                fetchDataRequest,
                ORG_SURVEY_ANSWERS_ENDPOINT,
                [ORGID_PATH_PARAM, 'orgSurveyId'],
                [selectedOrg ?.id, payload.orgSurveyId]
            ) || {};
            // TODO check if the return is an array
            yield put(fetchOrgSurveyAnswersSuccess(answers?.length > 0 ? answers[0] : answers));
        }
    } catch (error) {
        yield put(showOrgSurveyAnswersMessage(error.messages));
    }
}

function* saveOrgSurveyAnswers({ payload }) {
    try {
        const selectedOrg = yield select(currentOrg);
        let isNew = !payload ?.id || !payload ?.id.trim().length > 0;
        const savedOrgSurveyAnswers = yield call(
            addOrUpdateDataRequest,
            isNew ? [] : [{id: payload ?.id}], // so the addOrUpdateDataRequest will treat it as an add or update
            payload,
            'addOrgSurveyAnswers',
            'updateOrgSurveyAnswers',
            [ORGID_PATH_PARAM],
            [selectedOrg ?.id]
        );
        // const savedOrgSurveyAnswers = yield call(saveOrgSurveyAnswerRequest, payload);
        yield put(onSaveOrgSurveyAnswersSuccess(savedOrgSurveyAnswers));
    } catch (error) {
        yield put(showOrgSurveyAnswersMessage(error.messages));
    }
}

export function* fetchOrgSurveyAnswersSaga() {
    yield takeEvery(FETCH_ORG_SURVEY_ANSWERS, fetchOrgSurveyAnswers);
}

export function* saveOrgSurveyAnswersSaga() {
    yield takeEvery(ON_SAVE_ORG_SURVEY_ANSWERS, saveOrgSurveyAnswers);
}

export default function* rootSaga() {
    yield all([fork(fetchOrgSurveyAnswersSaga), fork(saveOrgSurveyAnswersSaga)]);
}


// WEBPACK FOOTER //
// ./sagas/OrgSurveyAnswer.js